<!-- FFルールグループ -->
<div class="p-fare-panel__body-item js-fix-height-3" id="p-fare-panel__body3-{{ slideNum }}">
  <ul class="c-available-list">
    <!-- 予約変更可否 -->
    <li class="c-available-list__item">
      <!-- 予約変更可能、手数料なし -->
      <ng-container *ngIf="this.fareFamiliesRule.itineraryPermit === 'free'">
        <div class="c-available-list__item-icon">
          <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
        </div>
        <div class="c-available-list__item-title" [innerHTML]="'label.itineraryPermitted' | staticMsg"></div>
      </ng-container>
      <!-- 予約変更可能、手数料あり -->
      <ng-container *ngIf="this.fareFamiliesRule.itineraryPermit === 'withPenalty'">
        <div class="c-available-list__item-icon">
          <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
        </div>
        <div class="c-available-list__item-title" [innerHTML]="'label.itineraryPermittedWithFee' | staticMsg"></div>
      </ng-container>
      <!-- 予約変更不可 -->
      <ng-container *ngIf="this.fareFamiliesRule.itineraryPermit === 'unavailable'">
        <div class="c-available-list__item-icon">
          <img src="assets/images/icon_feature_not_available_24.svg" width="24" height="24" />
        </div>
        <div class="c-available-list__item-title" [innerHTML]="'label.itineraryNotPermitted' | staticMsg"></div>
      </ng-container>
    </li>
    <!-- 払戻可否 -->
    <li class="c-available-list__item">
      <!-- 手数料なしで払い戻し可能 -->
      <ng-container *ngIf="this.fareFamiliesRule.refundPermit === 'free'">
        <div class="c-available-list__item-icon">
          <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
        </div>
        <div class="c-available-list__item-title" [innerHTML]="'label.refundPermitted' | staticMsg"></div>
      </ng-container>
      <!-- 手数料ありで払い戻し可能 -->
      <ng-container *ngIf="this.fareFamiliesRule.refundPermit === 'withPenalty'">
        <div class="c-available-list__item-icon">
          <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
        </div>
        <div class="c-available-list__item-title" [innerHTML]="'label.refundPermittedWithFee' | staticMsg"></div>
      </ng-container>
      <!-- 払い戻し不可 -->
      <ng-container *ngIf="this.fareFamiliesRule.refundPermit === 'unavailable'">
        <div class="c-available-list__item-icon">
          <img src="assets/images/icon_feature_not_available_24.svg" width="24" height="24" />
        </div>
        <div class="c-available-list__item-title" [innerHTML]="'label.refundNotPermitted' | staticMsg"></div>
      </ng-container>
    </li>
    <!-- 無料預け入れ手荷物個数 -->
    <!-- 個数の返却がある場合のみ表示 -->
    <ng-container *ngIf="this.fareFamiliesRule.isReceivedFreeBaggagePcs">
      <li class="c-available-list__item">
        <!-- 1個以上の場合、可能 -->
        <ng-container *ngIf="this.fareFamiliesRule.freeBaggagePcs! > 0">
          <div class="c-available-list__item-icon">
            <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
          </div>
          <div
            class="c-available-list__item-title"
            [innerHTML]="'label.freeBaggagePcs' | staticMsg : { '0': this.fareFamiliesRule.freeBaggagePcs }"
          ></div>
        </ng-container>
        <!-- 0個の場合、不可 -->
        <ng-container *ngIf="this.fareFamiliesRule.freeBaggagePcs! <= 0">
          <div class="c-available-list__item-icon">
            <img src="assets/images/icon_feature_not_available_24.svg" width="24" height="24" />
          </div>
          <div class="c-available-list__item-title" [innerHTML]="'label.notFreeBaggage' | staticMsg"></div>
        </ng-container>
      </li>
    </ng-container>
    <!-- 無料機内持ち込み手荷物個数 -->
    <!-- 個数の返却がある場合のみ表示 -->
    <ng-container *ngIf="this.fareFamiliesRule.isReceivedCarryOnBaggage">
      <li class="c-available-list__item">
        <!-- 1個以上の場合、可能 -->
        <ng-container *ngIf="this.fareFamiliesRule.carryOnBaggage! > 0">
          <div class="c-available-list__item-icon">
            <img
              src="assets/images/icon_feature_available_24.svg"
              width="24"
              height="24"
              alt="{{ 'alt.carryOnBaggagePcs' | staticMsg }}"
            />
          </div>
          <div
            class="c-available-list__item-title"
            [innerHTML]="'label.carryOnBaggagePcs' | staticMsg : { '0': this.fareFamiliesRule.carryOnBaggage }"
          ></div>
        </ng-container>
        <!-- 0個の場合、不可 -->
        <ng-container *ngIf="this.fareFamiliesRule.carryOnBaggage! === 0">
          <div class="c-available-list__item-icon">
            <img src="assets/images/icon_feature_not_available_24.svg" width="24" height="24" />
          </div>
          <div class="c-available-list__item-title" [innerHTML]="'label.notCarryOnBaggage' | staticMsg"></div>
        </ng-container>
      </li>
    </ng-container>
  </ul>
</div>
<!-- セグメント情報 セグメントの分ループ -->
<ng-container *ngFor="let segment of this.segmentList; index as segmentIndex">
  <div #fixHeight[3] class="p-fare-panel__body-item js-fix-height-4" id="p-fare-panel__body4-{{ slideNum }}">
    <div class="p-fare-panel__body-item-title">
      <!-- 出発地 -->
      {{ segment.departureAirport }}
      <span class="p-fare-panel__body-item-to">
        <span class="u-visually-hidden" [innerHTML]="'label.section' | staticMsg"></span>
        <span aria-hidden="true">{{ 'label.symbolBetweenSection' | staticMsg }}</span>
      </span>
      <!-- 到着地 -->
      {{ segment.arrivalAirport }}
    </div>
    <ul class="c-available-list">
      <li class="c-available-list__item">
        <!-- (25-37) 座席指定料金 -->
        <!-- 座席指定可(無料) -->
        <ng-container *ngIf="segment.seatReservationFee === 'included'">
          <div class="c-available-list__item-icon">
            <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
          </div>
          <div class="c-available-list__item-title" [innerHTML]="'label.asrFree' | staticMsg"></div>
        </ng-container>
        <!-- 座席指定不可 -->
        <ng-container *ngIf="segment.seatReservationFee === 'notOffered'">
          <div class="c-available-list__item-icon">
            <img src="assets/images/icon_feature_not_available_24.svg" width="24" height="24" />
          </div>
          <div
            class="c-available-list__item-title"
            [innerHTML]="'label.asr.chargeableType.impossible.sp' | staticMsg"
          ></div>
        </ng-container>
        <!-- (25-38) シートマップ -->
        <div class="c-available-list__item-contents">
          <p class="p-fare-panel__body-item-text">
            <a
              id="seatmap-link-{{ segmentIndex }}"
              class="p-fare-panel__body-item-text-link"
              href="javascript:void(0)"
              (throttleClick$)="
                this.seatmapReferenceParams(
                  segment.departureLocationCode,
                  segment.arrivalLocationCode,
                  segment.departureDateTime,
                  segment.marketingAirlineCode,
                  segment.marketingFlightNumber
                )
              "
              aswThrottleClick
            >
              <span class="p-fare-panel__body-item-text-link u-visually-hidden">{{
                segment.marketingAirlineCode! + segment.marketingFlightNumber
              }}</span>
              <span [innerHTML]="'link.seatMap' | staticMsg"></span>
              <img
                class="c-text-link-external"
                src="assets/images/icon_external_primary_16.svg"
                width="16"
                height="16"
                alt="{{ 'alt.openLinkInNewTab' | staticMsg }}"
              />
            </a>
          </p>
        </div>
      </li>
    </ul>
  </div>
</ng-container>
